module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control column"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          in: [_vm.targetValue]
        }
      }),
      expression: "{ rules: { required: true, in: [targetValue] } }"
    }],
    class: {
      'is-danger': _vm.errors.has('selection')
    },
    attrs: {
      "data-vv-name": "selection"
    }
  }, _vm._l((_vm.options), function(op) {
    return _c('option', [_vm._v(_vm._s(op))])
  }))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selection')),
      expression: "errors.has('selection')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n\t\tX\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e1b842!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selection.vue
// module id = 111
// module chunks = 2